var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "brick-root",
      class: [_vm.isActive ? "active" : "undefined", _vm.brickTypeName],
      attrs: { "data-jc-connection-id": _vm.connection.id },
      on: { mousedown: _vm.registerClickStart }
    },
    [
      _vm.deduplicationTargetEnabled
        ? _c(
            "brick-circle-base",
            {
              directives: [
                {
                  name: "tooltipped",
                  rawName: "v-tooltipped:[deduplicationTargetTooltip]",
                  value: _vm.tooltipsEnabled,
                  expression: "tooltipsEnabled",
                  arg: _vm.deduplicationTargetTooltip
                }
              ],
              staticClass: "journey-brick",
              on: { click: _vm.dedupTargetClick }
            },
            [
              _c("div", { staticClass: "brick-icon" }, [
                _c("img", { attrs: { src: _vm.DedupTargetIcon } })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deduplicationBaseEnabled
        ? _c(
            "brick-circle-base",
            {
              directives: [
                {
                  name: "tooltipped",
                  rawName: "v-tooltipped:[deduplicationBaseTooltip]",
                  value: _vm.tooltipsEnabled,
                  expression: "tooltipsEnabled",
                  arg: _vm.deduplicationBaseTooltip
                }
              ],
              staticClass: "journey-brick",
              on: { click: _vm.dedupBaseClick }
            },
            [
              _c("div", { staticClass: "brick-icon" }, [
                _c("img", { attrs: { src: _vm.DedupBaseIcon } })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.delayEnabled
        ? _c(
            "brick-circle-base",
            {
              directives: [
                {
                  name: "tooltipped",
                  rawName: "v-tooltipped:[delayTooltip]",
                  value: _vm.tooltipsEnabled,
                  expression: "tooltipsEnabled",
                  arg: _vm.delayTooltip
                }
              ],
              staticClass: "journey-brick",
              on: { click: _vm.delayClick }
            },
            [
              _c("div", { staticClass: "brick-icon" }, [
                _c("i", { staticClass: "fas fa-clock" })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.timerEnabled
        ? _c(
            "brick-circle-base",
            {
              directives: [
                {
                  name: "tooltipped",
                  rawName: "v-tooltipped:[timerTooltip]",
                  value: _vm.tooltipsEnabled,
                  expression: "tooltipsEnabled",
                  arg: _vm.timerTooltip
                }
              ],
              staticClass: "journey-brick",
              on: { click: _vm.timerClick }
            },
            [
              _c("div", { staticClass: "brick-icon" }, [
                _c("i", { staticClass: "fas fa-hourglass-half" })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.filterEnabled
        ? _c(
            "div",
            { staticClass: "journey-filter-checkpoint" },
            [
              _c(
                "brick-circle-base",
                {
                  directives: [
                    {
                      name: "tooltipped",
                      rawName: "v-tooltipped:[filterTooltip]",
                      value: _vm.tooltipsEnabled,
                      expression: "tooltipsEnabled",
                      arg: _vm.filterTooltip
                    }
                  ],
                  staticClass: "journey-brick",
                  on: { click: _vm.filterClick }
                },
                [
                  _c("div", { staticClass: "brick-icon" }, [
                    _c("i", { staticClass: "fas fa-map-signs" })
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.interactionFilterWithoutDelayTooltip
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltipped",
                          rawName:
                            "v-tooltipped:[interactionFilterWithoutDelayTooltip]",
                          value: _vm.tooltipsEnabled,
                          expression: "tooltipsEnabled",
                          arg: _vm.interactionFilterWithoutDelayTooltip
                        }
                      ],
                      staticClass:
                        "brick-icon interaction-filter-without-delay-warning"
                    },
                    [_c("i", { staticClass: "fas fa-exclamation" })]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.filterExclusionEnabled
        ? _c(
            "brick-circle-base",
            {
              directives: [
                {
                  name: "tooltipped",
                  rawName: "v-tooltipped:[filterExclusionTooltip]",
                  value: _vm.tooltipsEnabled,
                  expression: "tooltipsEnabled",
                  arg: _vm.filterExclusionTooltip
                }
              ],
              staticClass: "journey-brick journey-filter-exclusion-checkpoint",
              on: { click: _vm.filterExclusionClick }
            },
            [
              _c("div", { staticClass: "brick-icon" }, [
                _c("span", { staticClass: "fa-stack fa-1x" }, [
                  _c("i", { staticClass: "far fa-list-alt fa-stack-1x" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-ban fa-stack-2x" })
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "brick-circle-base",
        {
          directives: [
            {
              name: "tooltipped",
              rawName: "v-tooltipped:[optionsTooltip]",
              value: _vm.tooltipsEnabled,
              expression: "tooltipsEnabled",
              arg: _vm.optionsTooltip
            }
          ],
          staticClass: "journey-brick",
          on: { click: _vm.basicSettingsClick }
        },
        [
          _c("div", { staticClass: "brick-icon" }, [
            _c("i", { staticClass: "fas fa-bars" })
          ])
        ]
      ),
      _vm._v(" "),
      _vm.settingsOpen
        ? _c(_vm.editorType, {
            tag: "component",
            attrs: {
              connection: _vm.connection,
              config: _vm.config,
              "is-new": _vm.isEditingNewCheckpoint
            },
            on: {
              save: _vm.save,
              hidden: _vm.closeSettings,
              "change-status": _vm.statusChanged,
              "delete-connection-checkpoint": _vm.deleteCheckpoint,
              "delete-connection": _vm.deleteConnection
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }